import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedModule } from '@app/@shared';
import { WalletService } from '@app/@shared/services/wallet.service';
import { AlertController, IonicModule, ToastController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { ModalController } from '@ionic/angular';
import { CustomerService } from '@app/@shared/services/customer.service';
import { Timestamp } from 'firebase/firestore';
import { Customer } from '@app/@shared/models/customer.model';
import { Credentials, CredentialsService } from '@app/auth';
import { MailServiceService } from '@app/@shared/services/mail-service/mail-service.service';
@Component({
  selector: 'app-legal',
  standalone: true,
  imports: [CommonModule, IonicModule, SharedModule, TranslateModule],
  templateUrl: './legal.component.html',
  styleUrls: ['./legal.component.scss'],
})
export class LegalComponent implements OnInit {
  docs: Record<string, any> = {};
  expanded: string | null = null;
  selectedDoc: 'terms' | 'privacy' | 'responsible' | 'sportsRules' | '' = '';
  fromRegister = false;
  @Input() doc!: string;
  @Input() from!: string;
  showAutoModal = false;
  autoexclusionPeriodo = '';
  autoexclusionComentarios = '';
  credentials!: Credentials;
  customer!: Customer;

  constructor(
    public walletS: WalletService,
    private route: ActivatedRoute,
    private router: Router,
    private afs: AngularFirestore,
    public mailSrv: MailServiceService,
    private modalCtrl: ModalController,
    private servCustomer: CustomerService,
    private credentialsService: CredentialsService,
    private toastCtrl: ToastController,
    private alertController: AlertController
  ) {}
  async ngOnInit() {
    // 🔹 Si el componente se abre como modal (tiene Inputs)
    if (this.doc) {
      this.selectedDoc = this.doc as any;
      this.expanded = this.doc as any;
    }

    if (this.from === 'register') {
      this.fromRegister = true;
    }
    // 🔹 Si se abre por ruta (desde /legal)
    this.route.queryParams.subscribe((params) => {
      if (params['doc']) {
        const doc = params['doc'];
        if (['terms', 'privacy', 'responsible', 'sportsRules'].includes(doc)) {
          this.selectedDoc = doc;
          this.expanded = doc;
        }
      }

      if (params['from'] === 'register') {
        this.fromRegister = true;
      }
    });

    // 🔹 Cargar los documentos
    this.afs
      .collection('legal')
      .valueChanges({ idField: 'id' })
      .subscribe((data: any[]) => {
        this.docs = {};
        data.forEach((d) => {
          if (d.type) {
            this.docs[d.type] = d; // incluye sportsRules con pdfUrl
          }
        });
      });
  }

  close() {
    this.modalCtrl.dismiss();
  }

  selectDoc(doc: 'terms' | 'privacy' | 'responsible' | 'sportsRules') {
    this.selectedDoc = doc;
    this.expanded = doc;
  }

  async autoexclusion() {
    if (this.credentialsService.credentials?.customer?.exclusion) {
      const customer = this.credentialsService.credentials.customer;
      const timeEx = customer.timeEx;
      const periodEx = customer.periodEx as Timestamp; // Firestore Timestamp

      let formattedDate = '';

      // Convierte el Timestamp a Date
      const dateObj = periodEx.toDate();
      const today = new Date(); // Fecha actual
      // Formatear la fecha como "día de mes de año"
      formattedDate = dateObj.toLocaleDateString('es-ES', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      });

      if (today < dateObj) {
        // Mensaje dinámico según timeEx
        let message = '';
        if (timeEx === '0') {
          message =
            'Tu cuenta está actualmente en autoexclusión por tiempo indefinido. Si quieres reactivar tu acceso contacta a atencion_clientes@cmillonario.mx.';
        } else {
          message = `Tu cuenta está actualmente en autoexclusión por ${timeEx} meses, hasta el día ${formattedDate}.`;
        }

        const alert = await this.alertController.create({
          header: 'Autoexclusión activa',
          message,
          buttons: [
            {
              text: 'Aceptar',
              role: 'cancel',
            },
          ],
          cssClass: 'alert',
        });

        await alert.present();
      } else {
        await this.servCustomer.update(this.credentialsService.credentials.id, { exclusion: false });
        this.credentialsService.credentials.customer.exclusion = false;
        this.showAutoModal = true;
      }
    } else {
      this.showAutoModal = true;
    }
  }

  closeAutoModal() {
    this.showAutoModal = false;
  }

  async guardarAutoexclusion() {
    const credentials = this.credentialsService.credentials!;

    const now = new Date();
    let dateFin: Timestamp | null = null;

    const meses = Number(this.autoexclusionPeriodo);

    if (meses > 0) {
      const fechaFin = new Date(now);
      fechaFin.setMonth(fechaFin.getMonth() + meses);
      dateFin = Timestamp.fromDate(fechaFin);
    }

    const updateData: any = {
      exclusion: true,
      timeEx: this.autoexclusionPeriodo,
      comentExclusion: this.autoexclusionComentarios,
      dateExclusion: Timestamp.now(),
    };

    if (dateFin) {
      updateData.periodEx = dateFin;
    }

    await this.servCustomer.update(credentials.id, updateData);

    const customer = this.credentialsService.credentials?.customer;
    if (customer) {
      customer.exclusion = true;
      customer.periodEx = dateFin as Timestamp;
      customer.timeEx = this.autoexclusionPeriodo;
    }

    const toast = await this.toastCtrl.create({
      message:
        'Exclusion inciada: Recuerda que jugar debe ser siempre una experiencia divertida y responsable, y estamos aquí para apoyarte en cada paso',
      duration: 4000,
      buttons: [
        {
          icon: 'close',
        },
      ],
    });

    await toast.present();
    let periodText =
      Number(this.autoexclusionPeriodo) === 0 ? 'tiempo indefinido' : `${this.autoexclusionPeriodo} meses`;

    let bodyMail = {
      name: this.credentialsService.credentials?.name || 'Cliente',
      period: periodText,
    };
    await this.mailSrv.sendMail('d-e6dd4c3860ce4f95b0f84473805ddf28', bodyMail, '');

    this.showAutoModal = false;
  }

  toggleDoc(doc: string) {
    this.expanded = this.expanded === doc ? null : doc;
  }

  goToRegister() {
    if (this.fromRegister || this.from === 'register') {
      this.close(); // Cierra el modal
    } else {
      this.router.navigate(['/home'], { queryParamsHandling: 'preserve' });
    }
  }

  get isAuthenticated(): boolean {
    return this.credentialsService.isAuthenticated();
  }
}
